export default {
  inquiryQuote: {
    title: '询报价',
    detailTitle: '询报价详情',
    createTitle: '新建询价',
    editTitle: '编辑询价',

    filters: {
      inquiryNo: '询价编号',
      source: '询价来源',
      quoteSource: '报价来源',
      quoteStatus: '报价状态',
      consultationStatus: '磋商状态',
      salesQuoterId: '销售报价人',
      businessQuoterIds: '商务报价人',
      inquiryTargetIds: '供应商',
      inquirerId: '询价人',
      clientId: '询价客户',
      all: '全部'
    },

    options: {
      sourceInternal: '内部',
      sourceClient: '客户',
      sourceAgentWecom: '企微Agent',
      sourceCargowareXAgent: 'CargowareX Agent',
      sourceEmailAgent: 'Email Agent',
      sourceFamilyAgent: 'Family Agent',
      /** @deprecated 旧原型文案，保留避免遗漏引用 */
      sourceCustomer: '外部',
      sourceInternalSales: '内部',
      sourceWallTechFamily: '被委托',
      quoteSourceSales: '销售报价',
      quoteSourceBusiness: '商务报价',
      quoteSourceSupplier: '供应商报价',
      quoteStatusPendingSales: '待销售报价',
      quoteStatusPendingBusiness: '待商务报价',
      quoteStatusPendingSupplier: '待供应商报价',
      quoteStatusQuoted: '已报价',
      quoteStatusPending: '待报价',
      quoteStatusNotQuoted: '未报价',
      consultationNone: '未磋商',
      consultationInProgress: '磋商中',
      consultationDone: '磋商完成',
      intentionYes: '有意向',
      intentionNo: '无意向',
      intentionConsidering: '考虑中',
      intentionOrder: '意向单',
      direct: '直达',
      transit: '中转'
    },

    bizTabs: {
      sea: '海运',
      air: '空运',
      rail: '铁路',
      prePort: '港前',
      lastMile: '尾程'
    },

    toolbar: {
      create: '新建询价',
      query: '查询',
      reset: '重置',
      totalSummary: '共 {inquiryCount} 条询价，{quoteCount} 条报价记录',
      columnSettings: '列设置',
      selectAll: '全选',
      cancelSelect: '取消',
      inquiryInfo: '询价信息',
      salesQuoteInfo: '销售报价信息',
      businessQuoteInfo: '商务报价信息',
      supplierQuoteInfo: '供应商报价信息',
      salesQuoteDetail: '销售报价明细',
      businessQuoteDetail: '商务报价明细',
      supplierQuoteDetail: '供应商报价明细',
      actions: '操作',
      carrier: '承运人',
      cargoType: '货物类型',
      transportMode: '运输方式',
      segmentPrePort: '港前',
      segmentTrunk: '干线',
      segmentLastMile: '尾程'
    },

    columns: {
      inquiryNo: '询价编号',
      inquiryNoTip: '获取询价时系统自动生成的询价编码',
      source: '询价来源',
      sourceTip: '与后端询价来源一致：内部、客户、企微Agent、CargowareX Agent、Email Agent、Family Agent',
      userId: '询价用户',
      userIdTip: '展示询价操作人名称+所属企业',
      inquirerName: '询价人名称',
      inquirerPhone: '询价人手机号',
      inquirerPhoneTip: '询价人联系电话：系统接收到询价自动带出询价方登录账号人手机号 / 新建询价录入',
      inquirerEmail: '询价人邮箱',
      inquirerEmailAlt: '询价人邮件',
      inquirerEmailTip: '询价人联系邮箱：系统接收到询价自动带出询价方登录账号人邮箱 / 新建询价录入',
      inquiryTime: '询价时间',
      inquiryTimeTip: '系统接收到询价数据的时间',
      cargoReadyTime: '货好时间',
      cargoReadyTimeTip: '询价提交时手动填写内容',
      etd: '期望开航时间',
      etdTip: '询价提交时手动填写内容',
      palletNature: '货盘性质',
      palletNatureTip: '询价提交时手动填写内容',
      quoteDeadline: '报价截止',
      quoteDeadlineTip: '询价提交时手动填写内容',
      cargoValueDisplay: '货值(币种)',
      cargoValueDisplayTip: '询价填写的货值金额+对应币种',
      directTransit: '直达/中转',
      directTransitTip: '询价选定的运输方式：直达 / 中转',
      transitPoint: '中转点',
      transitPointTip: '询价填写的中转站点，直达时为空',
      salesQuoterName: '销售报价人',
      salesQuoterNameTip: '询价单 salesQuoterId（向商务询价时写入）',
      salesQuoteStatus: '销售报价状态',
      salesQuoteStatusTip: '销售主报价状态：0-无 / 1-待报价 / 2-已报价',
      businessQuoterName: '商务报价人',
      businessQuoterNameTip: '询价单 businessQuoterIds；多个时折叠「主报价人 +N」，悬停查看全部',
      businessQuoteStatus: '商务报价状态',
      businessQuoteStatusTip: '商务主报价状态：0-无 / 1-待报价 / 2-已报价',
      supplierQuoterName: '供应商',
      supplierQuoterNameTip: '询价 inquiryTargetIds（报价供应商企业）；多个时折叠「主名称 +N」，悬停或拉宽列查看全部',
      supplierQuoteStatus: '供应商报价状态',
      supplierQuoteStatusTip: '供应商主报价状态：0-无 / 1-待报价 / 2-已报价',
      inquiryPath: '询价路径',
      inquiryPathTip: '拼接格式：收货地→起运港→卸货港→目的港。收货地：装货城市/港/站/地址；起运港：起运国/城市/(港/机场/站)；卸货港：目的国/城市/(港/机场/站)；目的港：目的国/城市/(目的地/第三方地址/仓库编码)；单元格下方融合展示承运人、货物类型、运输方式'
    },

    roleColumns: {
      businessQuoteNo: '商务报价号',
      businessPrice: '商务价格',
      salesQuoteNo: '销售报价号',
      salesPrice: '销售价格',
      supplierQuoteNo: '供应商报价号',
      supplierPrice: '供应商价格',
      orderIntention: '下单意向',
      carrier: '承运人',
      placeOfReceipt: '收货地',
      pol: '起运港',
      pod: '卸货港',
      placeOfDelivery: '目的港',
      transitPort: '中转港',
      consultationStatus: '磋商状态',
      quoteTime: '报价时间',
      priceDetails: '价格明细',
      remark: '备注'
    },

    actions: {
      detail: '详情',
      edit: '编辑',
      create: '新建询价'
    },

    messages: {
      loadFailed: '加载询报价数据失败'
    },

    empty: {
      noInquiry: '暂无询价记录'
    },

    autoQuote: {
      status: {
        enabled: '自动报价已开启：销售报价 Tab 下存在符合运价时立即自动报价',
        disabled: '自动报价未开启：匹配到运价需手动选择报价（开关在「个人设置 → 报价设置」）',
        strategy: '（策略：{strategy}）',
        newInquiryOnly: '（仅对新询价生效）',
        goToSettings: '去设置'
      },
      settings: {
        title: '报价设置',
        enable: '自动报价',
        enableDescription: '开启后，销售报价 Tab 下存在符合询价的运价时立即自动报价（无定时延迟）；仅对开启后到达的新询价生效',
        strategy: '默认报价策略',
        strategyDescription: '存在多条符合运价时，按策略选取用于自动报价的运价',
        lowestTotal: '优先最低价存在多条符合运价时，优先选择总价最低的运价',
        ownedRateFirst: '优先自有运价优先使用运价库自有运价（自有运价维护）',
        latestRateFirst: '优先最新运价优先使用最新上架（起运日最近）的符合运价',
        strategyNames: {
          lowestTotal: '优先最低价',
          ownedRateFirst: '优先自有运价',
          latestRateFirst: '优先最新运价'
        },
        save: '保存设置',
        saved: '设置保存成功',
        loadFailed: '加载自动报价设置失败',
        saveFailed: '保存自动报价设置失败',
        descriptionTitle: '自动报价说明',
        removedDelayTitle: '已移除定时逻辑：',
        removedDelay: '不再按「延迟回复时间」倒计时触发，是否自动报价仅由上方开关控制。',
        immediateTitle: '立即报价：',
        immediate: '开关开启后，新到达的询价在销售报价 Tab 下存在符合运价时立即生成系统自动报价，无需人工操作。',
        newInquiryTitle: '仅对新询价生效：',
        newInquiry: '保存设置后仅对之后到达的询价生效；已有报价的询价不受影响，不追溯修改。',
        followUpTitle: '后续跟进：',
        followUp: '自动报价记录与手动报价一致进入报价数据与报价跟进，销售可基于自动报价与客户持续沟通。'
      }
    },

    detail: {
      title: '询报价详情',
      inquiryInfo: '询价信息',
      quoteInfo: '报价信息',
      tabs: {
        sales: '销售报价 ({count})',
        business: '商务报价 ({count})'
      },
      sections: {
        quoteData: '报价数据',
        businessQuoteData: '商务报价数据',
        supplierQuoteData: '供应商报价数据',
        recommendedRates: '推荐运价',
        notQuotedYet: '尚未报价',
        countItems: '{count} 条',
        notQuoted: '暂未报价'
      },
      actions: {
        selectRate: '选择运价',
        inquireBusiness: '向商务询价',
        inquireSupplier: '向供应商询价',
        submitQuote: '提交报价',
        submitQuoteWithCount: '提交报价（{count}）',
        uploadAttachment: '上传附件',
        createQuoteManually: '手动创建报价',
        viewDetail: '查看详情',
        negotiate: '磋商',
        negotiationHistory: '磋商记录'
      },
      tips: {
        salesTab:
          '从已上架运价库多选运价批量报价（可勾选船期、选择是否报 all-in 价格），或发起询价由商务报价；勾选商务报价 / 推荐运价后可提交报价',
        salesTabAir:
          '从已上架运价库多选运价批量报价（选择是否报 all-in 价格），或发起询价由商务报价；勾选商务报价 / 推荐运价后可提交报价',
        businessTab: '手动创建报价将进入运价维护新建界面，可「保存并报价」生成商务报价；勾选供应商报价 / 推荐运价后可提交报价'
      },
      messages: {
        loadInquiryFailed: '加载询价详情失败',
        missingInquiryId: '缺少询价 ID，无法加载详情',
        inquiryNotFound: '询价详情不存在',
        loadDetailFailed: '加载询报价详情失败',
        loadRecommendFailed: '加载推荐运价失败',
        selectBizOrRecommend: '请至少勾选一条商务报价或推荐运价',
        selectSupplierOrRecommend: '请至少勾选一条供应商报价或推荐运价',
        selectComboOrEcommerce: '请至少勾选一条联运组合或电商运价',
        selectAtLeastOneRate: '请至少选择一条运价',
        missingInquiryIdSubmit: '缺少询价 ID，无法提交报价',
        nothingToSubmit: '没有可提交的报价',
        submitSalesSuccess: '已提交 {count} 条销售报价',
        submitBusinessSuccess: '已提交 {count} 条商务报价',
        submitSalesFailed: '提交销售报价失败',
        submitBusinessFailed: '提交商务报价失败',
        generateSalesSuccess: '已生成 {count} 条销售报价',
        inquireBusinessSuccess: '已向商务发起询价',
        inquireSupplierSuccess: '已向 {count} 个供应商联系人发起询价',
        inquireBusinessFailed: '向商务询价失败',
        inquireSupplierFailed: '向供应商询价失败',
        selectBusinessFirst: '请选择商务人员后再发起询价',
        selectSupplierContactFirst: '请至少选择一个供应商联系人后再发起询价',
        selectSupplierFirst: '请选择供应商后再发起询价',
        missingInquiryIdCreateRate: '缺少询价 ID，无法创建运价',
        missingInquiryIdInquire: '缺少询价 ID，无法发起询价',
        missingQuoteIdImport: '缺少报价 ID，无法导入运价库',
        importModeNotReady: '当前运输模式（{mode}）暂未接入导入运价库接口',
        consultationStarted: '已发起磋商',
        consultationSent: '已发送磋商请求',
        consultationFailed: '发起磋商失败',
        enterExpectedPrice: '请输入期望价格',
        missingQuoteIdConsult: '缺少有效的报价 ID，无法发起磋商',
        selectQuoteToConsult: '请选择要磋商的报价',
        supplierConfirmed: '供应商已确认',
        confirmSupplierFailed: '确认供应商失败',
        selectValidSupplierQuote: '请选择有效的供应商报价',
        loadSailingsFailed: '加载船期失败',
        noTrunkForSailing: '该组合无干线运价，无法查询船期',
        loadShelfRatesFailed: '加载已上架运价库失败',
        enterMarkupAmount: '请先输入加价金额',
        enterMarkupAmountPerBox: '请先输入加价金额（USD/箱）',
        enterMarkupAmountShort: '请输入加价金额',
        quickMarkupBoth: '已对该分组快捷加价（小箱 +25 / 大箱 +50，票价 +25）',
        quickMarkupBox: '已对该分组快捷加价（小箱 +25 / 大箱 +50）',
        quickMarkupKg: '已对该分组快捷加价（每公斤 +25）',
        quickMarkupTicket: '已对该分组快捷加价（每票 +25）',
        quickMarkupGlobal: '已快捷加价（小箱 +25 / 大箱 +50，票价 +25）',
        applyMarkupKg: '已对「{label}」应用加价 USD {amt}/公斤',
        applyMarkupBoxTicket: '已对「{label}」应用加价 USD {amt}/箱（票）',
        applyMarkupBox: '已对「{label}」应用加价 USD {amt}/箱',
        applyMarkupTicket: '已对「{label}」应用加价 USD {amt}/票',
        applyMarkupBoxDone: '已应用加价（USD {amt}/箱）',
        weightMarkup: '重量段加价{amt}',
        weightMarkupSpaced: '重量段加价 {amt}',
        noMarkupRows: '当前运价没有可加价的费用行',
        noBoxMarkupRows: '当前运价没有可按箱加价的费用行',
        reQuoteNoFees: '该报价暂无费用明细，无法确认报价',
        reQuoteNothing: '没有可提交的费用明细',
        reQuoteMissingId: '缺少有效的报价 ID，无法提交确认报价',
        reQuoteSuccess: '已提交确认报价，磋商状态更新为「磋商完成」',
        reQuoteFailed: '提交确认报价失败',
        selectQuoteFirst: '请先选择一条报价',
        inquiryAlreadyOrdered: '该询价单已生成订单，无法再次订舱',
        quoteMissingForBooking: '报价信息不存在，无法发起订舱',
        bookingConfirmFailed: '确认订舱失败',
        selectSupplierQuoteToConfirm: '请选择要确认的供应商报价',
        noConfirmedSupplierQuote: '当前没有已确认的供应商报价',
        cannotCancelImported: '该报价已导入运价库，不可取消确认',
        cancelConfirmSuccess: '取消确认成功',
        cancelConfirmFailed: '取消确认供应商失败',
        confirmImportOk: '确认导入',
        confirmImportSchemeContent: '确定将「{supplier}」的「{scheme}」导入运价库吗？',
        cancelConfirmContent: '确定取消当前已确认供应商吗？',
        missingInquiryIdValid: '缺少有效询价 ID'

      },
      supplier: {
        sentSuppliers: '已发送供应商',
        quoteTable: '供应商报价',
        quotedCount: '{quoted}/{total} 家已报价',
        confirmSupplier: '确认供应商',
        cancelConfirmSupplier: '取消确认供应商',
        noQuotes: '暂无报价',
        waitingQuotes: '已发送询价至 {count} 家供应商，等待报价中...'
      },
      customer: {
        title: '客户',
        analysis: '客户分析',
        followUp: '报价跟进',
        noAnalysis: '暂无客户分析数据',
        noFollowUp: '暂无跟进记录'
      },

      labels: {
        status: '状态',
        supplier: '供应商',
        schemeName: '报价方案',
        supplierQuoteNo: '供应商报价编码',
        carrier: '船公司',
        voyageDays: '航程',
        voyageDaysWithUnit: '航程(天)',
        voyageHoursWithUnit: '航程(小时)',
        prePortFee: '港前费用',
        trunkFee: '干线费用',
        lastMileFee: '尾程费用',
        totalFee: '综合费用',
        validity: '有效期',
        quoteTime: '报价时间',
        confirmStatus: '确认状态',
        consultationStatus: '磋商状态',
        importStatus: '导入状态',
        negotiate: '磋商',
        actions: '操作',
        basicInfo: '基本信息',
        quotationAttachment: '报价单附件',
        supplierQuotationAttachment: '供应商报价单附件',
        noAttachment: '暂无附件',
        currency: '币制',
        currencyShort: '币种',
        serviceType: '服务类型',
        trunkFreight: '干线运费',
        feeItem: '费用项',
        feeName: '费用名称',
        fee: '费用',
        boxType: '箱型',
        unitPrice: '单价',
        quantity: '数量',
        subtotal: '小计',
        billingUnit: '计费单位',
        remark: '备注',
        remarkColon: '备注：',
        unit: '单位',
        expectedPrice: '期望价格',
        expectedPriceColon: '期望价格：',
        consultNote: '磋商说明',
        consultNoteColon: '磋商说明：',
        changeContentColon: '变更内容：',
        pol: '起运港',
        pod: '目的港',
        rateSource: '运价来源',
        vesselVoyage: '船名 / 航次',
        routeCode: '航线代码',
        boxOwner: '箱属',
        commodity: '品名',
        segTotal: '段合计',
        notCountTotal: '不计入总价',
        chargeUnit: '计费单位',
        pricingMode: '计价方式',
        select: '选择',
        vessel: '船名',
        voyage: '航次',
        lane: '航线',
        departureFreq: '开船频率',
        customsCutoff: '截关',
        portCutoff: '截港',
        space: '舱位',
        inquiryTotalLabel: '询价总价',
        sellTotalTimesQty: '卖价总价×箱量',
        origTotalColon: '原价总价：',
        quoteTotalColon: '报价总价：',
        sellTotalColon: '卖价总价：',
        costTotalColon: '成本总价：',
        sellPriceSuffix: '{ct} 卖价',
        costPriceSuffix: '{ct} 成本',
        segTotalColon: '{seg}总价：',
        feeDetail: '费用明细',
        inquiryBoxUnitTotal: '询价箱型单价 / 箱量总价',
        trunkSegInquiryPrice: '干线段询价箱型价格（海运费/基础运价）',
        trunkFeeDetail: '干线费用明细（含附加费，按费用原币）',
        scheduleInfo: '船期信息',
        laneCodeTag: '航线 {code}',
        voyageDaysTag: '航程 {days} 天',
        voyageHoursTag: '航程 {hours} 小时',
        validityColon: '有效期：',
        validityRange: '{from} 至 {to}',
        days: '{n} 天',
        daysCompact: '{n}天',
        dateRange: '{from} ~ {to}',
        currentQuoteUsd: '当前报价 USD {amount}',
        none: '无',
        originalPrice: '原价',
        quotePrice: '报价',
        sellPrice: '销售卖价',
        salesQuote: '销售报价',
        subtotalUsd: '小计 (USD)',
        mBand: 'M段',
        mBandMinPerTicket: '最低收费·每票',
        hitBand: '命中段({label})',
        chargeableWeight: '计费重 {weight}',
        ticketOrig: '费用(票)',
        ticketOrigPrice: '原价',
        ticketQuotePrice: '报价',
        boxSubtotal: '箱型小计',
        total: '合计',
        usdPerBox: 'USD/箱',
        pricingByBox: '分箱型',
        airTrunk: '空运干线',
        surchargeColon: '附加费：',
        remarkContentColon: '备注内容：',
        defaultChecked: '默认选中',
        contactColon: '联系人：',
        quoteTimeColon: '报价时间：',
        templateColon: '模板：{name}',
        weightLimit: '限重',
        volumeWeightFactor: '体积重系数',
        freeDemurrageDays: '免堆存天数',
        flightNo: '航班号',
        detention: '滞箱费',
        demurrage: '滞港费',
        loadingPlaceInfo: '装货地信息',
        originPlaceInfo: '起运地信息',
        pickupAddressInfo: '提货地址信息',
        destPlaceInfo: '目的地信息',
        storeAddress: '门店地址',
        bargeCarrier: '驳船船公司',
        loadingPort: '装货港',
        bargeVessel: '驳船船名',
        bargeVoyage: '驳船航次',
        expectedDeparture: '预计开航',
        expectedArrival: '预计到港',
        bargeVoyageDays: '驳船航程',
        loadingStation: '装货站',
        routeCategory: '线路分类',
        trainNo: '车次',
        departureTime: '发车时间',
        addressType: '地址类型',
        originTerminal: '起运码头',
        railwayStation: '铁路站点',
        originAirport: '起运机场',
        airportCargoStation: '机场货站',
        unloadTerminal: '卸货码头',
        unloadStation: '卸货站',
        unloadAirport: '卸货机场',
        thirdPartyAddress: '第三方地址',
        warehouseAddress: '仓库地址',
        destTerminal: '目的港码头',
        bargeDepartureTime: '驳船开航时间',
        bargeArrivalTime: '驳船到港时间',
        directFly: '直飞',
        feeType: '费用类型',
        paymentTerms: '付费条款',
        weightSegment: '重量段',
        airMShow: '空运费取：M 展示',
        minCharge: '最低收费',
        maxCharge: '最高收费',
        costTotal: '成本总价',
        sellTotal: '销售卖价总价',
        inquiryBoxType: '询价箱型',
        prePortSegTitle: '📍 港前段',
        trunkSegTitle: '🚢 干线段',
        lastMileSegTitle: '📍 尾程段',
        remarkContent: '备注内容',
        smartMarkup: '智能加价',
        apply: '应用',
        close: '关闭',
        cancel: '取消',
        send: '发送',
        confirm: '确认',
        back: '返回',
        completed: '已完成'
      },
      status: {
        pending: '待报价',
        quoted: '已报价',
        rejected: '已拒绝',
        confirmed: '已确认',
        unconfirmed: '未确认',
        imported: '已导入',
        notImported: '未导入',
        consulting: '磋商中',
        notConsulted: '未磋商'
      },
      units: {
        box: '箱',
        ticket: '票',
        day: '天',
        days: '{n} 天',
        daysCompact: '{n}天',
        perBox: '每柜',
        kg: '公斤',
        households: '{count}家',
        countItems: '{count} 条'
      },
      fees: {
        oceanFreight: '海运费',
        oceanSurcharge: '海运附加费',
        originPortFee: '起运港费用',
        destPortFee: '目的港费用',
        other: '其他',
        prePortFreight: '港前运费',
        prePortSurcharge: '港前附加费',
        prePortOther: '港前其他',
        lastMileFreight: '尾程运费',
        lastMileSurcharge: '尾程附加费',
        lastMileOther: '尾程其他',
        feeItem: '费用项',
        fee: '费用',
        airFreight: '空运费',
        railFreight: '铁路运费',
        airTrunkSurcharge: '干线附加费',
        airOriginFee: '起飞地费用',
        airDestFee: '目的地费用',
        railSurcharge: '铁路附加费',
        freight: '运费',
        prePortFee: '港前费用',
        lastMileFee: '尾程费用',
        totalFee: '综合费用',
        trunkFreight: '干线运费'
      },
      sort: {
        smart: '智能推荐',
        inquiryTotal: '询价总价',
        voyageDays: '航程',
        label: '排序'
      },
      combo: {
        precise: '精准组合',
        free: '自由组合',
        totalCost: '综合费用',
        prefillTip: '询价已包含港前/干线/尾程运价段，已按询价起运港/目的港/船公司预填组合查询条件，选择所需运价组合',
        prefillTipAir: '询价已包含港前/干线/尾程运价段，已按询价起飞机场/目的机场/航空公司预填组合查询条件，选择所需运价组合',
        linkedTip: '联运组合：已按询价条件匹配，勾选后可提交报价',
        scheduleTip: '勾选后随所选运价组合一并提交报价',
        viewSchedule: '查看船期'
      },
      ratePicker: {
        selectedCount: '已选 {count} 条运价',
        fclTip: '已选 {count} 条运价；仅展示询价相关箱型，询价总价按询价箱量计算；可展开「查看船期」勾选具体船期',
        allIn: '报 all-in 价格（不带费用明细）',
        submitBizInquiry: '提交商务询价',
        titleWithMode: '选择运价 · {mode}',
        title: '选择运价',
        specialBoxWarn: '询价含特殊箱型（冷藏/框架等），该箱型无标准运价，未计入询价总价',
        ecommerceLatest: '电商运价',
        ecommerceLatestSub: '（班期最新价）',
        recommendOfflineTop: '（前 {count}，4 箱型价格总和低→高）',
        recommendMatchSub: '按询价 起运国/城市/港 → 运价起运港；目的国/城市/港 → 运价目的港 匹配',
        recommendMatchSubAir: '按询价 起运国/城市/机场 → 运价起飞机场；目的国/城市/机场 → 运价目的机场 匹配',
        modes: {
          combined: '组合查询',
          fcl: '整箱运价',
          lcl: '拼箱运价',
          air: '空运运价',
          rail: '铁路运价',
          express: '快递运价',
          preport: '港前运价',
          lastmile: '尾程运价',
          roro: '滚装运价',
          bulk: '散杂货运价'
        },
        modeShort: {
          air: '空运',
          rail: '铁路',
          trunk: '干线'
        },
        lclPrice: '拼箱:${price}/{unit}'
      },
      modals: {
        schemeDetail: '报价明细 - {name}',
        startConsultation: '发起磋商',
        negotiationHistory: '磋商记录',
        salesDetail: '销售报价详情',
        businessDetail: '商务报价详情',
        recommendDetail: '推荐运价详情',
        comboDetail: '组合运价明细',
        viewSchedule: '查看船期',
        reQuote: '确认报价 — {no}',
        confirmQuote: '确认报价（按询价箱型箱量计算报价价格）',
        confirmQuoteByUnit: '确认报价（按计费单位计算报价价格）',
        confirmImport: '确认导入运价库',
        cancelConfirmSupplier: '取消确认供应商'
      },
      confirmQuote: {
        srcBiz: '商务报价',
        srcSupplier: '供应商报价',
        srcCombined: '组合报价',
        srcEcommerce: '电商运价',
        srcRate: '运价库/推荐',
        perBoxMarkup: '每箱型 +25/+50',
        smartDesc: '输入自定义加价金额，加价将回显到每条运价海运费行（加价 = 原价 + 输入金额），可再逐费用行微调',
        smartHint: '加价将应用到每条运价海运费行，可再逐费用行微调',
        generate: '确认生成报价',
        remarkPickup: '接货说明',
        remarkOverweight: '超重备注',
        remarkFreeDays: '免箱期',
        remarkOther: '其他备注',
        phPickup: '接货特殊说明',
        phOverweight: '超重备注',
        phFreeDays: '目的港免用箱 X 天',
        phOther: '其他备注',
        freeDaysValue: '目的港免用箱 {days} 天',
        footerCombo: '组合运价段确认后合并生成 1 条组合聚合报价，报价价格 = 组合各段含加价合计',
        footerBizExtra: '商务报价底价逐条生成',
        footerSupplierExtra: '供应商报价底价逐条生成',
        footerMixed: '混合报价：{labels}生成报价，报价价格 = 上述含加价合计',
        footerBiz: '生成后销售卖价 = 商务报价加权总价，报价价格 = 上述含加价合计',
        footerSupplier: '生成后商务底价 = 供应商报价成本，报价价格 = 上述含加价合计',
        footerRateBiz: '生成后商务底价 = 询价加权总价，报价价格 = 上述含加价合计',
        footerRateSales: '生成后销售卖价 = 询价加权总价，报价价格 = 上述含加价合计',
        labelBizBase: '商务报价底价',
        labelSupplierBase: '供应商报价底价',
        labelRateLib: '运价库/推荐运价',
        reQuoteHint: '提交后生成新一轮磋商记录，磋商状态变更为「磋商完成」',
        reQuoteRemarkPh: '填写确认报价备注（接货特殊说明、超重/免箱期等，将随报价单展示给客户）',
        reQuoteSubmit: '提交确认报价',
        quoteTotalWithBase: '报价合计 {total}；底价 USD {base}',
        quoteTotalUsdWithBase: '报价合计 USD {quote}；底价 USD {base}',
        airHitRemark: '计费重命中段 {label}',
        airMOrig: '；M段保底原价 {orig}',
        airMQuote: ' / 报价 {quote}',
        perTicket: '每票'
      },
      supplierExtra: {
        sentCount: '已发送供应商 ({count}家)',
        unlinked: '未关联供应商',
        schemeFallback: '报价方案',
        noSalesQuoteHint: '该询价尚未产生销售报价，可点击上方「选择运价」报价',
        noBusinessQuoteHint: '该询价尚未产生商务报价，可点击上方「手动创建报价」或「向供应商询价」',
        inquiryNotFound: '未找到该报价所属的询价',
        localTrailer: '本地拖车服务商',
        localDelivery: '本地派送服务商',
        demoSalesQuoter: '刘销售',
        prePortCostTag: '港前 {amount}',
        lastMileCostTag: '尾程 {amount}',
        surchargeCostTag: '附加费 {amount}',
        supplierFallback: '供应商'
      },
      apiSegments: {
        prePort: '港前段',
        trunk: '干线段',
        lastMile: '尾程段'
      },
      apiStatus: {
        spaceAvailable: '有空',
        spaceTight: '紧张',
        consulting: '磋商中',
        completed: '完成',
        expectedPrice: '期望价格',
        expectedPriceLine: '期望价格：{price}',
        consultNote: '磋商说明',
        consultNoteLine: '磋商说明：{note}',
        expectedAndNote: '期望价格：{price}\n磋商说明：{note}'
      },
      apiFeeMatch: {
        oceanFreight: '海运费',
        surcharge: '附加',
        destPort: '目的港',
        originPort: '起运港',
        docFee: '单证费',
        fileFee: '文件费',
        freight: '运费',
        kg: '公斤',
        kgAlt: '千克'
      },
      apiCarrierAlias: {
        cosco: '中远海运',
        maersk: '马士基',
        msc: '地中海航运',
        one: '海洋网联',
        cma: '达飞轮船',
        evergreen: '长荣海运',
        hpl: '赫伯罗特',
        whl: '万海航运',
        yml: '阳明海运'
      },
      placeholders: {
        expectedPrice: '请输入期望价格，如：USD 2500',
        consultNote: '请输入磋商说明，如期望调整的项目、原因等'
      },

      empty: {
        noRecommend: '暂无匹配的推荐运价',
        noData: '暂无数据',
        noMatch: '暂无匹配',
        noShelfRates: '暂无已上架运价',
        noComboData: '暂无符合数据，提交商务询价',
        noSailings: '暂无匹配船期',
        noNegotiation: '暂无磋商记录',
        noTrunkFee: '暂无干线费用明细'
      }
    },

    quoteTable: {
      salesQuoteNo: '销售报价编码',
      businessQuoteNo: '商务报价编码',
      actions: '操作',
      viewDetail: '查看详情',
      negotiate: '磋商',
      negotiationHistory: '磋商记录',
      priceDetails: '价格明细',
      selectedSailings: '已选船期',
      boxType: '箱型',
      oceanFreight: '海运费',
      surcharge: '附加费',
      originalPrice: '原价',
      quotePrice: '报价',
      cost: '成本',
      sellPrice: '卖价',
      direct: '直达',
      directFly: '直飞',
      viaTransit: '经 {port}',
      transitFallback: '中转',
      sailingDepart: '开航',
      consultationStatus: '磋商状态',
      orderIntention: '下单意向',
      directTransit: '直达/中转',
      directFlyTransit: '直飞/中转',
      quoteTime: '报价时间',
      validity: '价格有效期',
      prePortAddress: '港前地址',
      lastMileAddress: '尾程地址',
      airline: '航空公司',
      departureAirport: '起飞机场',
      arrivalAirport: '目的机场',
      transitAirport: '中转机场',
      railCompany: '铁路公司',
      originStation: '起运站',
      destStation: '目的站',
      exitPort: '出境口岸',
      entryPort: '入境口岸',
      transitStation: '中转站',
      containerOwner: '箱属',
      loadingPlace: '装货地',
      transportMode: '运输方式',
      originPlace: '起运地',
      pickupAddress: '提货地址',
      destAddress: '目的地址',
      carrier: '承运人',
      placeOfReceipt: '收货地',
      pol: '起运港',
      unloadPort: '卸货港',
      pod: '目的港',
      transitPort: '中转港',
      loadingTerminal: '起运港码头',
      dischargeTerminal: '卸货港码头',
      vessel: '船名',
      voyage: '航次',
      routeCode: '航线代码',
      sellTotalUsd: '卖价总价（USD）',
      prePortTransportMode: '港前运输方式',
      lastMileTransportMode: '尾程运输方式',
      segmentOrigQuote: '{segment}原价总价 / 报价总价',
      segmentCostSell: '{segment}成本 / 销售卖价',
      segmentPrePort: '港前',
      segmentTrunk: '干线',
      segmentLastMile: '尾程',
      consultationNone: '未磋商',
      consultationInProgress: '磋商中',
      consultationDone: '磋商完成',
      intentionYes: '有意向',
      intentionNo: '无意向',
      intentionConsidering: '考虑中',
      intentionOrder: '意向单'
    },

    recommendedRates: {
      empty: '暂无符合运价',
      carrier: '船公司',
      route: '起运港/目的港',
      validity: '有效期',
      inquiryTotal: '询价合计',
      segment: '运价段',
      loadingPort: '起运港',
      destinationPort: '目的港',
      carrierOrProvider: '船公司/服务商',
      containerType: '箱型',
      price: '运价',
      currency: '币种',
      voyageDays: '航程(天)',
      dataSourceEcommerce: '电商',
      dataSourceOffline: '线下',
      dataSourceCargoware: 'Cargoware',
      shelfOn: '已上架',
      shelfOff: '未上架',
      ecommerceReason: '电商运价',
      ecommerceTitle: '电商最新价，报价有竞争力',
      cargowareMeta: '应付海运费 · {count} 单成交',
      cargowareMetaWithPeriod: '应付海运费 · {count} 单成交 · {period}',
      fclBox: '整箱'
    }
  }
}
